import React from 'react'
import MitigationModalContent from './MitigationModalContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';

const MitigationModal = ({  barrierName,
                            setShowMBarrierModal,
                            pModel,
                            ITEMS_PER_PAGE, 
                            currentPage, 
                            setCurrentPage,
                            currentItems, 
                            startIndex, 
                            checkedState, 
                            setCheckedState,
                            errors, 
                            radioState,
                            setRadioState,
                            validatePage,
                            submitMitigationEffectHandler,
                            }) => {
  return (
    <div>
         <div style={{ fontFamily: 'MavenPro' }} className='absolute bg-black/30 z-[9999] w-full h-full flex justify-center items-center'>
          <div className=' flex-col justify-center items-center'>
            <div className='bg-gray-100/90 w-[800px] shadow-md rounded-xl border border-2 border-gray-300 p-8 pb-5'>
              <div className='flex justify-end text-black'><FontAwesomeIcon className='cursor-pointer' onClick={() => {
                setShowMBarrierModal(false);
              }} icon={faClose} size='xl' /></div>
              <div className='text-xl uppercase text-gray-800 text-center font-semibold '>Mitigation Effectiveness</div>
              <div className='w-32 h-[2px] bg-gray-500 mx-auto mb-5 mt-1' />
              <div className='mx-5'> 
                <div className='text-2xl  mb-3 text-gray-900/80 capitalize'><span className='font-bold'>Mitigation Name:</span> {barrierName}</div>
                <div className='font-semibold text-xl mb-5 text-fuchsia-900/80'>Check all criteria this barrier may affect. For each checked item, select the effectiveness and confidence. </div>
                <MitigationModalContent 
                  pModel={pModel} 
                  ITEMS_PER_PAGE={ITEMS_PER_PAGE} 
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  currentItems={currentItems}
                  startIndex={startIndex}
                  checkedState={checkedState}
                  setCheckedState={setCheckedState}
                  errors={errors}
                  radioState={radioState}
                  setRadioState={setRadioState}
                  validatePage={validatePage}
                  submitMitigationEffectHandler={submitMitigationEffectHandler}
                  />
              </div>
              </div>  
        </div>
        </div>
    </div>
  )
}

export default MitigationModal